import { render, staticRenderFns } from "./HolidaysOtherPlans.vue?vue&type=template&id=9ff1860c&"
import script from "./HolidaysOtherPlans.vue?vue&type=script&lang=js&"
export * from "./HolidaysOtherPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports